// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1__S8","cls2":"Comments-cls2__yv Comments-cls1__S8","short":"Comments-short_JGF"};